(ns ncr.search.item
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [clojure.set :as set]
   [clojure.string :as str]
   [goog.string :as gstring]
   [goog.string.format :as gf]
   [lambdaisland.glogi :as log]
   [taoensso.encore :as e]
   [uix.core.alpha :as uix]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.me :as me]
   [ncr.widgets.core :as w]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.reload :as rel]
   [ncr.etc.pf :as pf :refer [l-flex l-flex-item]]
   [ncr.fragment.folder :as fragment-folder]
   [ncr.fragment.label :as fragment-label]
   [ncr.fragment.access :as fragment-access]
   [ncr.fragment.common :as fragment-common]
   [ncr.fragment.attachment-label :as fragment-attachments]
   [ncr.fragment.attachments-backend :as ba]
   [ncr.search.selection :as sel]
   [ncr.widgets.datev]
   [ncr.fragment.props :as fragment-props]))

(defn c-attachments [props {:keys [attachments] :as fragment}]
  [wpf/c-label-group {:class :ncr-c-attachment-list}
   (for [attachment (sort-by :fileName attachments)]
     [fragment-attachments/c-attachment-label props fragment attachment])])

(defn c-item-body [{:keys [me list-item? blurred? open-in-new-tab? track-origin]} {:keys [properties] :as entry}]
  (let [editable? (not list-item?)]
    [l-flex {:direction :column :space-items :space-items-sm}
     [l-flex
      {:justify-content :justify-content-space-between
       :align-items :align-items-center
       :flex-wrap :nowrap}

      [fragment-common/c-folder entry]

      (when (seq (:labels entry))
        [l-flex-item {:flex :flex-none}
         [fragment-common/c-labels
          {:editable? editable?
           :track-origin track-origin
           :open-in-new-tab? open-in-new-tab?} entry]])

      [:div {:class :ncr-u-text-truncate__container}
       [fragment-common/c-name
        {:editable? editable?
         :open-in-new-tab? open-in-new-tab?}
        entry]]

      [l-flex-item {:flex :flex-none}
       [fragment-access/c-access-line {:me me} entry]]]

     (when-not list-item?
       [l-flex
        [l-flex-item
         [fragment-common/c-description {} entry]]])

     [l-flex
      (if list-item?
        {:align-items :align-items-top}
        {:justify-content :justify-content-space-between})

      [l-flex-item {:flex :flex-1}
       (let [props-line [fragment-props/c-properties-line {:blurred? blurred? :fragment-id (:id entry)} properties]]
         (if list-item?
           [l-flex {:direction :row}
            props-line
            [c-attachments
             {:open-in-new-tab? open-in-new-tab? :show-tooltip? true :icons #{:datev :textract}}
             entry]]
           props-line))]

      [l-flex-item (when list-item? {:flex :flex-none})
       [fragment-common/c-date {} entry]]]]))

(defn c-item-date-separator [[text class]]
  [pf/c-data-list-item {:class [:ncr-c-search-list__separator class]}
   [pf/c-data-list-item-row
    [pf/c-data-list-item-cells {}
     [pf/c-data-list-cell text]]]])

(defn c-item [{:keys [me blurred? selectable? open-in-new-tab? track-origin]} {:keys [id folder] :as entry}]
  (let [selected (sel/use-selected)
        selected? (contains? selected id)]
    [pf/c-data-list-item
     {:class :pf-m-selectable
      :style {:cursor :default}}
     [pf/c-data-list-item-row
      (when selectable?
        [pf/c-data-list-checkbox
         {:checked selected?
          :on-click u/stop-propagation
          :on-change
          (fn [e]
            (u/stop-propagation e)
            (if selected?
              (sel/deselect! id)
              (sel/select! id)))}])
      [pf/c-data-list-item-cells {}
       [pf/c-data-list-cell
        [c-item-body
         {:me me
          :list-item? true
          :blurred? blurred?
          :open-in-new-tab? open-in-new-tab?
          :track-origin track-origin}
         entry]]]

      (let
        [handler
         (fn [action-fn]
           (fn [_]
             (go
               (u/when-ok [_ (<! (action-fn me [entry]))]
                 (ps/pub! [:search/execute false])))))

         in-trash? (= folder (get (me/trash-folder me) :id))]

        (let [{:keys [ownerWritableHint writableHint promotedHint revoked]} entry]
          [pf/c-data-list-action {:class :pf-u-ml-0 :on-click u/stop-propagation}
           [pf/c-dropdown-menu
            {:dropdown-items
             [[pf/c-dropdown-item
               {:icon [w/c-menu-icon {:icon :tag-multiple-outline}]
                :is-disabled (or (not writableHint) in-trash?)
                :on-click (handler fragment-label/!edit-labels)}
               "Labels"]

              [pf/c-dropdown-item
               {:icon [w/c-menu-icon {:icon :folder-move-outline}]
                :is-disabled (or promotedHint (not writableHint))
                :on-click (handler fragment-folder/!move)}
               "Move"]

              [pf/c-dropdown-item
               {:icon [w/c-menu-icon {:icon :pencil-outline}]
                :is-disabled (or (not writableHint) in-trash?)
                :on-click (handler fragment-common/!fragment-edit)}
               "Edit"]

              (let [{:keys [status allowed]} (get-in me [:caps :datev])]
                (when (and promotedHint (= :connected status))
                  [:<>
                   [pf/c-dropdown-separator]
                   [pf/c-dropdown-item
                    {:icon [w/c-menu-icon {:icon :cloud-arrow-up-outline}]
                     :is-disabled (or (not allowed) (not :promotedHint))
                     :on-click (handler ncr.widgets.datev/schedule-upload!)}
                    "Upload to DATEV"]]))

              [pf/c-dropdown-separator]

              [pf/c-dropdown-item
               {:icon [w/c-menu-icon {:icon :account-multiple-outline}]
                :is-disabled (or (not promotedHint) (not ownerWritableHint))
                :on-click (handler fragment-access/!permissions)}
               "Permissions"]

              (when-not promotedHint
                [pf/c-dropdown-item
                 {:icon [w/c-menu-icon {:icon :rocket-launch-outline}]
                  :is-disabled (or promotedHint (not writableHint) in-trash?)
                  :on-click (handler fragment-access/!promote)}
                 "Move to Accepted"])

              [pf/c-dropdown-separator]

              (cond
                (not promotedHint)
                [pf/c-dropdown-item
                 {:icon [w/c-menu-icon {:icon :trash-can-outline}]
                  :is-disabled (or (not writableHint) in-trash?)
                  :on-click
                  (handler fragment-folder/!move-to-trash)}
                 "Move to Trash"]

                revoked
                [pf/c-dropdown-item
                 {:icon [w/c-menu-icon {:icon :rocket-launch-outline}]
                  :is-disabled (not writableHint)
                  :on-click (handler fragment-common/!quick-unrevoke)}
                 "Return to Accepted"]

                :else
                [pf/c-dropdown-item
                 {:icon [w/c-menu-icon {:icon :trash-can-outline}]
                  :is-disabled (not writableHint)
                  :on-click (handler fragment-common/!quick-revoke)}
                 "Revoke"])]}]]))]]))
